import React from 'react';
import PropTypes from 'prop-types';
import { Container, Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import FadeIn from 'react-fade-in';
import { useTranslation } from 'react-i18next';
import Page from 'src/components/Page';
import TerminationAuditToolbar from './TerminationAuditToolbar';
import { TerminationAuditList } from './TerminationAuditList';

const useStyles = makeStyles()(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const TerminationAuditListView = ({ config }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Page className={classes.root} title={t(config.titleKey)}>
      <FadeIn transitionDuration={200}>
        <Container maxWidth={false}>
          <TerminationAuditToolbar config={config} />
          <Box mt={3}>
            <TerminationAuditList config={config} />
          </Box>
        </Container>
      </FadeIn>
    </Page>
  );
};

TerminationAuditListView.propTypes = {
  config: PropTypes.object.isRequired
};

export default TerminationAuditListView;
